export default "__VITE_ASSET__C4rJW3gf__"